export function isPromiseResultFulfilled<T>(result: PromiseSettledResult<T>): result is PromiseFulfilledResult<T> {
	return result.status === 'fulfilled';
}

export function isPromiseResultRejected<T>(result: PromiseSettledResult<T>): result is PromiseRejectedResult {
	return result.status === 'rejected';
}
